import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LogOut, User } from "lucide-react";
import { LOGO_GOLD, NAV_LINKS } from "../../lib/constants";
import { useAuth } from "../../lib/auth";

export default function Header() {
    const [open, setOpen] = useState(false);
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const dashboardPath = user && user.role
        ? (["super_admin","founder","athlete_agent","compliance","finance","social_manager","content_creator"].includes(user.role)
            ? "/mgmt/dashboard"
            : user.role === "sponsor" ? "/sponsor/dashboard" : "/athlete/dashboard")
        : null;

    return (
        <>
        <header className="glass-nav fixed top-0 left-0 right-0 z-50" data-testid="site-header">
            <div className="max-w-[1400px] mx-auto px-5 md:px-8 h-[68px] flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
                    <img src={LOGO_GOLD} alt="Digital Beast" className="h-9 md:h-10 w-auto" />
                    <span className="hidden sm:block font-display text-[15px] tracking-[0.28em] uppercase text-white">Digital Beast</span>
                </Link>

                <nav className="hidden xl:flex items-center gap-6">
                    {NAV_LINKS.slice(0, 8).map(l => (
                        <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
                            className={({isActive}) => `text-[13px] font-medium tracking-wide transition-colors ${isActive ? "text-[#d4af37]" : l.highlight ? "text-[#d4af37]/80 hover:text-[#d4af37]" : "text-white/70 hover:text-white"}`}>
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-2 md:gap-3">
                    <Link to="/apply" className="hidden md:inline-flex btn-gold text-[12px] px-4 py-3" data-testid="header-apply-btn">
                        Apply
                    </Link>
                    <Link to="/brands" className="hidden lg:inline-flex btn-outline text-[12px] px-4 py-3" data-testid="header-partner-btn">
                        Partner
                    </Link>
                    {user ? (
                        <div className="hidden md:flex items-center gap-2">
                            <Link to={dashboardPath} className="btn-ghost flex items-center gap-2 text-[13px] max-w-[160px]" data-testid="header-dashboard-btn">
                                <User size={16} className="flex-shrink-0" /> <span className="truncate">{user.name.split(" ")[0]}</span>
                            </Link>
                            <button onClick={() => { logout(); navigate("/"); }} className="btn-ghost" data-testid="header-logout-btn" aria-label="Logout">
                                <LogOut size={16} />
                            </button>
                        </div>
                    ) : (
                        <Link to="/login" className="hidden md:inline-block btn-ghost text-[13px]" data-testid="header-login-btn">
                            Login
                        </Link>
                    )}
                    <button className="xl:hidden text-white p-2" onClick={() => setOpen(true)} aria-label="Menu" data-testid="header-menu-btn">
                        <Menu size={24} />
                    </button>
                </div>
            </div>
        </header>

            {open && (
                <div className="fixed inset-0 z-[100] xl:hidden overflow-y-auto" style={{ background: "#050505" }} data-testid="mobile-menu">
                    <div className="h-[68px] flex items-center justify-between px-5 md:px-8 border-b border-white/10 sticky top-0" style={{ background: "#050505" }}>
                        <img src={LOGO_GOLD} alt="Digital Beast" className="h-9" />
                        <button onClick={() => setOpen(false)} className="text-white p-2" data-testid="mobile-menu-close" aria-label="Close">
                            <X size={24} />
                        </button>
                    </div>
                    <div className="p-6 space-y-5">
                        {NAV_LINKS.map(l => (
                            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
                                className={({isActive}) => `block font-display text-2xl tracking-wider uppercase ${isActive ? "text-[#d4af37]" : "text-white/85"}`}>
                                {l.label}
                            </NavLink>
                        ))}
                        <div className="pt-6 border-t border-white/10 space-y-3">
                            {user ? (
                                <>
                                    <Link to={dashboardPath} onClick={() => setOpen(false)} className="btn-gold w-full justify-center" data-testid="mobile-dashboard-btn">
                                        My Dashboard
                                    </Link>
                                    <button onClick={() => { logout(); setOpen(false); navigate("/"); }}
                                        className="btn-outline w-full justify-center" data-testid="mobile-logout-btn">Log out</button>
                                </>
                            ) : (
                                <>
                                    <Link to="/login" onClick={() => setOpen(false)} className="btn-outline w-full justify-center" data-testid="mobile-login-btn">Log in</Link>
                                    <Link to="/apply" onClick={() => setOpen(false)} className="btn-gold w-full justify-center" data-testid="mobile-apply-btn">Apply for Representation</Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
